import { render, staticRenderFns } from "./generacionArchivoTarjeta.vue?vue&type=template&id=3e86a72d"
import script from "./generacionArchivoTarjeta.vue?vue&type=script&lang=js"
export * from "./generacionArchivoTarjeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports